/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import buttonStyles from './button.styles';

type ButtonType = 'key' | 'primary' | 'link' | 'black';

type PropTypes = {
    type?: ButtonType;
    text: string;
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    css?: any;
    styles?: any;
};

export const Button: FC<PropTypes> = ({
    type = 'primary',
    text,
    onClick,
    disabled = false,
    isLoading = false,
    css = {},
    styles,
}) => {
    const getButtonTypeStyle = () => {
        switch (type) {
            case 'key':
                return buttonStyles.key;
            case 'link':
                return buttonStyles.link;
            case 'black':
                return buttonStyles.black;
            default: {
                return buttonStyles.primary;
            }
        }
    };

    return (
        <>
            <button
                disabled={disabled || isLoading}
                css={[
                    buttonStyles.button,
                    getButtonTypeStyle,
                    css,
                    styles,
                    disabled || isLoading ? buttonStyles.disabled : {},
                ]}
                onClick={() => !disabled && onClick()}>
                {isLoading ? <CircularProgress size={20} /> : text}
            </button>
        </>
    );
};
